import React from "react";
import { Link } from "react-router-dom";

import Icon from "@ant-design/icons";

import { useConfigCenter } from "core/context/ConfigCenter";
import { PageType } from "shared/constants/PageType";

// import { ReactComponent as Instagram } from "assets/icons/instagram.svg";
import { ReactComponent as X} from "assets/icons/x.svg";
import { ReactComponent as Telegram } from "assets/icons/telegram.svg";
import { ReactComponent as Discord } from "assets/icons/discord.svg";
import { ReactComponent as Age } from "assets/icons/age18.svg";

import { RouteUrls } from "routing/routing.constants";

import "./Footer.scss";

export const Footer: React.FC = React.memo(() => {
  const [, { changePage }] = useConfigCenter();
  return (
    <div className="footer">
      <div className="ooyoot-logo" />
      <div className="game-name footer__title" />
      <div className="footer__links">
        <Link to={RouteUrls.COOKIE_POLICY_URL} onClick={(event) => changePage(PageType.COOKIE_POLICY, undefined, event)}>
          Cookie policy
        </Link>
        <Link to={RouteUrls.PRIVACY_POLICY_URL} onClick={(event) => changePage(PageType.PRIVACY_POLICY, undefined, event)}>
          Privacy policy
        </Link>
        <Link to={RouteUrls.TERMS_OF_USE_URL} onClick={(event) => changePage(PageType.TERMS_OF_USE, undefined, event)}>
          Terms of use
        </Link>
        <Link to={RouteUrls.GAME_RULES_URL} onClick={(event) => changePage(PageType.GAME_RULES, undefined, event)}>Game rules</Link>
      </div>
      <div className="footer__wax">
          <Link to={`${RouteUrls.WAX_WALLET_URL}/`} onClick={(event) => changePage(PageType.WAX_WALLET, undefined, event)}>
              Get WAX Wallet for free
          </Link>
      </div>
      <div className="footer__social">
        <a
          href="https://twitter.com/Neuroborncats"
          rel="noreferrer"
          target="_blank"
        >
          <Icon className="x-icon" component={X} />
        </a>
        {/*<a href="https://www.instagram.com/gatialabs/" rel="noreferrer" target="_blank">*/}
        {/*  <Icon className="instagram-icon" component={Instagram} />*/}
        {/*</a>*/}

        <a href="https://t.me/neuroborncats" rel="noreferrer" target="_blank">
          <Icon className="telegram-icon" component={Telegram} />
        </a>

        <a
          href="https://discord.gg/MgV32NTpAH"
          rel="noreferrer"
          target="_blank"
        >
          <Icon className="discord-icon" component={Discord} />
        </a>
      </div>
      <div className="footer__info">
        <span>NEUROBORN CATS: THE GAME</span>
        <span>®/TM & © GATIA LABS ALL RIGHTS RESERVED.</span>
      </div>
      <div className="footer__age">
          <Icon className="footer__age-image" component={Age}/>
      </div>
    </div>
  );
});
